import React, { useEffect } from "react";
import { Form, Checkbox } from "antd";

function CheckboxPicker({
  form,
  name,
  label,
  width,
  labelCol,
  required,
  errorMessage,
  validateFunction,
  defaultValue,
  options,
  onChange,
  disabled,
  className
}) {

  useEffect(() => {
    if (defaultValue) {
      form.setFieldsValue({ [name]: defaultValue });
    }
  }, []);

  return (
    <Form.Item
      className={className}
      name={name}
      label={label}
      labelCol={{ span: labelCol ? labelCol : 8 }}
      style={{ width: width, fontWeight: 600 }}
      rules={[
        {
          required: required,
          message: errorMessage,
        },
        () => ({
          validator(rule, value) {
            return validateFunction
              ? validateFunction(rule, value)
              : Promise.resolve();
          },
        }),
      ]}
    >
      <Checkbox.Group
        disabled={disabled}
        defaultValue={defaultValue}
        style={{ fontWeight: 600, width: "100%" }}
        onChange={onChange}
      >
        {options.map((opt, index) => {
          return (
            <Checkbox key={index} value={opt.value} style={{ fontWeight: 600 }}>
              {opt.label}
            </Checkbox>
          );
        })}
      </Checkbox.Group>
    </Form.Item>
  );
}

export default CheckboxPicker;
